import content from './cms-content.json';
export const FEE = content.fee.amount;

// Editorial intake content sourced from the CMS (cms.briefIntake).
// The brief.js internal ranking logic (privacy/waterfront/finance bias)
// stays in buildBrief below — it matches by neighborhood name against the
// CMS-provided hoodDB, not by hard-coded strings.
const INTAKE = content.briefIntake || {};
export const audiences = INTAKE.audiences || ['Individual', 'Family'];
export const intents = INTAKE.intents || ['Relocation', 'Office space', 'Events', 'Full concierge'];
export const interestLabels = INTAKE.interests || [
  'Privacy & security', 'Art & galleries', 'Fine dining', 'Schools & family',
  'Members\u2019 clubs', 'Finance proximity', 'Waterfront', 'Architecture',
];
export const matchLines = INTAKE.searchSteps || [
  'Parsing brief',
  'Cross-referencing 412 buildings',
  'Filtering by discretion index',
  'Mapping social adjacencies',
  'Confirming off-market availability',
  'Compiling dossier',
];

export const hoodDB = INTAKE.matchedNeighborhoods || [
  { name: 'Tribeca', note: 'Cast-iron lofts, quiet money' },
  { name: 'West Village', note: 'Townhouse privacy' },
  { name: 'Upper East Side', note: 'Old guard, closed doors' },
  { name: 'NoMad', note: 'Central, discreet, clubbable' },
  { name: 'Brooklyn Heights', note: 'Promenade views, slower clock' },
  { name: 'Hudson Yards', note: 'New, vertical, visible' },
  { name: 'SoHo', note: 'Seen, on your terms' },
  { name: 'Battery Park City', note: 'Water on three sides' },
];

export const audienceSummaries = INTAKE.audienceSummaries || {
  Family: 'We tailor the brief for a household with children — schools, space, and neighborhood fit.',
  Individual: 'A brief tuned to one person’s move and priorities.',
};
export const intakeLabels = {
  arrangingAsLabel: INTAKE.arrangingAsLabel || 'I am arranging this as',
  intentPromptLabel: INTAKE.intentPromptLabel || 'I am looking to',
  mattersPrompt: INTAKE.mattersPrompt || 'What matters to you',
  mattersSuffix: INTAKE.mattersSuffix || '— select any',
  nameLabel: INTAKE.nameLabel || 'Name',
  namePlaceholder: INTAKE.namePlaceholder || 'Full name',
  channelLabel: INTAKE.channelLabel || 'Encrypted channel',
  channelPlaceholder: INTAKE.channelPlaceholder || 'Email or Signal',
  submitLabel: INTAKE.submitLabel || 'Submit brief & begin search →',
  footnote: INTAKE.footnote || 'No data shared · Reviewed by a human advisor',
  searchHeader: INTAKE.searchHeader || 'Searching the city',
  sourcesSuffix: INTAKE.sourcesSuffix || ' sources queried',
  dossierLabel: INTAKE.dossierLabel || 'Preliminary Dossier',
  matchedLabel: INTAKE.matchedLabel || 'Matched neighborhoods',
  residenceLabel: INTAKE.residenceLabel || 'RESIDENCE',
  officeLabel: INTAKE.officeLabel || 'OFFICE',
  venueLabel: INTAKE.venueLabel || 'VENUE',
  instructionsBlock: INTAKE.instructionsBlock || 'This is the surface. Secure your dossier and a dedicated advisor will reach out by encrypted channel within 24 hours.',
  checkoutButtonPrefix: INTAKE.checkoutButtonPrefix || 'Secure your dossier — ',
  checkoutButtonSuffix: INTAKE.checkoutButtonSuffix || ' via Stripe',
  newBriefLabel: INTAKE.newBriefLabel || 'Start a new brief',
  openingStripeLabel: INTAKE.openingStripeLabel || 'Opening secure Stripe checkout…',
  stripeStatus: INTAKE.stripeStatus || 'Encrypted · PCI compliant',
  successHeader: INTAKE.successHeader || 'A secure payment link is on its way.',
  successBodyPrefix: INTAKE.successBodyPrefix || 'We\'ve sent a Stripe checkout link to your encrypted channel. Once ',
  successBodySuffix: INTAKE.successBodySuffix || ' is settled, your advisor begins within 24 hours.',
};
const dossierResidences = INTAKE.dossierResidences || ['Brooklyn Heights townhouse', 'Tribeca cast-iron penthouse'];
const dossierOffices = INTAKE.dossierOffices || ['Hudson Yards full floor', 'NoMad private floor'];
const dossierVenues = INTAKE.dossierVenues || ['Chelsea gallery + members\u2019 dinner', 'NoMad members\u2019 club'];
const dossierIdPrefix = INTAKE.dossierIdPrefix || 'NYC-';

export function buildBrief(intent, interests) {
  let pool = hoodDB.slice();
  if (interests.includes('Privacy & security')) pool = ['West Village', 'Tribeca', 'Upper East Side'].map((n) => hoodDB.find((d) => d.name === n)).concat(pool);
  if (interests.includes('Waterfront')) pool = ['Brooklyn Heights', 'Battery Park City'].map((n) => hoodDB.find((d) => d.name === n)).concat(pool);
  if (interests.includes('Finance proximity')) pool = ['Hudson Yards', 'Battery Park City'].map((n) => hoodDB.find((d) => d.name === n)).concat(pool);
  const seen = {};
  const hoods = [];
  pool.forEach((d) => { if (d && !seen[d.name]) { seen[d.name] = 1; hoods.push(d); } });
  const top = hoods.slice(0, 3);
  const id = dossierIdPrefix + Math.floor(1000 + Math.random() * 8999);
  const residence = interests.includes('Waterfront') ? dossierResidences[0] : dossierResidences[1];
  const office = (intent === 'Office space' || interests.includes('Finance proximity')) ? dossierOffices[0] : dossierOffices[1];
  const venue = interests.includes('Art & galleries') ? dossierVenues[0] : dossierVenues[1];
  return { id, intent, hoods: top, residence, office, venue };
}
